'use strict';

var React = require('react');

var SvgButtonCornerPillMajor = function SvgButtonCornerPillMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.28 2.79c-7.45 0-13.49 6.04-13.49 13.49v3.72h-2.79v-3.72c0-8.993 7.288-16.28 16.28-16.28h3.72v2.79h-3.72z"
  }));
};

exports.SvgButtonCornerPillMajor = SvgButtonCornerPillMajor;
